'use client';

/**
 * Injects CSS without React text-escaping the <style> contents.
 * Plain <style>{`…`}</style> in JSX causes SSR to emit &quot; while the
 * client expects ", triggering React hydration error #425/#418.
 *
 * Post-build note: scripts/inline-critical-css.js MUST keep
 * reduceInlineStyles:false so Beasties does not relocate/rewrite these
 * React-owned <style> nodes (that causes sitewide #418/#423).
 */
export default function InlineStyle({ css }) {
  return <style data-lb-inline-style="" dangerouslySetInnerHTML={{ __html: css }} />;
}
